import { Component, Inject, OnInit } from "@angular/core";
import { VNG_DIALOG_DATA, VngDialogRef } from "@vengreso/angular-components";
import { Subscription, tap, timer } from "rxjs";
import { DialogService } from "src/app/core/core-services/services/dialog.service";
import { SharedDataService } from "../../core/core-services/services/shared-data.service";
import { environment } from "src/environments/environment";
import { ExtensionService } from "../../core/core-services/services/extension.service";

/**
 * panelClass this dialog opens with — do not change the value (queried by
 * DialogService.hasOpenDialogWithClass/closeDialogWithClass; other call
 * sites, e.g. AdminLayoutComponent.shouldDownloadExtension(), still open it
 * with the literal string, so keep them in sync if this ever changes).
 * Exported so issue #518's live-install detection (WelcomeModalComponent)
 * can dismiss an already-open nag without duplicating the literal.
 */
export const WELCOME_NAG_DIALOG_CLASS = "welcome-dialog";

@Component({
    selector: "app-welcome",
    templateUrl: "./welcome.component.html",
    standalone: false
})
export class WelcomeComponent implements OnInit {
  browser_type;
  show = false;

  timerDuration = environment.production ? 60000 : 8640000;
  timerSub$: Subscription;

  modalTimer;
  modalOpened = false;

  constructor(
    @Inject(VNG_DIALOG_DATA) public data: any,
    public dialogRef: VngDialogRef<WelcomeComponent>,
    private readonly sharedData: SharedDataService,
    private readonly dialog: DialogService,
    private readonly extensionService: ExtensionService
  ) {
    this.browser_type = this.sharedData.getAttribute("browser_type");
    if (this.browser_type == "firefox" || this.browser_type == "opera" || this.browser_type == "safari") {
      this.show = false;
    } else {
      this.show = true;
    }
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }

  navigateToExtension() {
    this.close();
    this.extensionService.openExtensionStorePage();
  }

  // remindMeLater() {
  //   this.sharedData.setAttribute("welcomeRemindMe", (new Date().getTime()));
  //   this.close();
  // }

  dismiss() {
    this.sharedData.setAttribute("welcomeDismiss", true);
    this.close();
  }

  displayExtensionPrompt() {
    this.sharedData.showExtensionPrompt.next(true);
    this.dismiss();
  }

  remindMeLater() {
    this.close();
    clearTimeout(this.modalTimer);

    this.modalTimer = setTimeout(async () => {
      // VngDialogService has no public openDialogs list (unlike MatDialog) —
      // DialogService.hasOpenDialogWithClass tracks it for us instead.
      if (this.dialog.hasOpenDialogWithClass(WELCOME_NAG_DIALOG_CLASS)) {
        this.modalOpened = true;
      }

      if (this.modalOpened) {
        return;
      }

      if (
        location.href.includes("session/signin") ||
        location.href.includes("session/signup") ||
        location.href.includes("session/pricing")
      ) {
        return;
      }

      // Issue #518: re-check install state right before reopening — the nag
      // used to reopen unconditionally on this timer, even when the user had
      // installed the extension in the meantime. `{ fresh: true }` bypasses
      // ExtensionService's session cache (which only short-circuits
      // POSITIVE results) so a just-completed install is actually seen.
      const isInstalled = await this.extensionService.isExtensionInstalled({ fresh: true });
      if (isInstalled) {
        return;
      }

      this.dialog.openDialogComponent(
        WelcomeComponent,
        {
          self: this,
          // do not change the name of this class
          class: WELCOME_NAG_DIALOG_CLASS,
        },
        "400px",
        true
      );
    }, this.timerDuration);

    ////////////
    // this.timerSub$ = timer(this.timerDuration).pipe(
    //   tap((x)=>{
    //     this.sharedData.showDownloadModalTimer.next(true)
    //   }),
    // ).subscribe();
    // this.sharedData.showDownloadModalTimer.next(false)
    // this.timerSub$?.unsubscribe()
    // this.close()
  }
}
